import HolifyaLogoComplete from "../../../components/HolifyaLogoComplete";

interface FormBoxProps {
    title?: string;
    description: string;
    formContent: React.ReactNode;
    actionButton?: React.ReactNode;
    onSubmit: (e: React.FormEvent) => void;
}

const FormBox: React.FC<FormBoxProps> = ({
    title,
    description,
    formContent,
    actionButton,
    onSubmit,
}) => {
    return (
        <div className="w-full flex flex-col items-center space-y-5">
            {title ? <div className="font-bold text-2xl text-center">
                {title}
            </div> : <HolifyaLogoComplete />}
            {description && <div className="font-normal text-base text-center">
                {description}
            </div>}
            <form className="w-full space-y-5" onSubmit={onSubmit}>
                {formContent}
            </form>
            {actionButton && (
                <div className="w-full">
                    {actionButton}
                </div>
            )}
        </div>
    )
}

export default FormBox
